// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__xgtR0","innerFooter":"Footer_innerFooter__DDA5T"};